import {defineStore} from "pinia";
import {useAuthenticationStore} from "@/stores/authentication";

export const useSelfServiceStore = defineStore('selfService', {
    state: () => ({
        authenticated: false,
        servers: [],
        email: '',
        step: 'email'
    }),
    actions: {
        async requestOtp(email) {
            await useAuthenticationStore().getCSRFToken();
            await this.axios.post('/selfservice/request-otp/', {email});
            this.email = email;
            this.step = 'code';
        },
        async verifyOtp(code, remember) {
            const response = await this.axios.post('/selfservice/verify-otp/',
                {email: this.email, code, remember_device: remember});
            this.authenticated = true;
            this.servers = response.data.servers;
        },
        async getSession() {
            try {
                const response = await this.axios.get('/selfservice/session/');
                this.authenticated = response.data.authenticated;
                this.servers = response.data.servers;
            } catch (e) {
                console.log(e);
            }
        },
        async listEmails() {
            const response = await this.axios.get('/selfservice/emails/');
            return response.data;
        },
        async requestEmailChange(newEmail) {
            await useAuthenticationStore().getCSRFToken();
            await this.axios.post('/selfservice/change-email/request/', {email: newEmail});
        },
        async verifyEmailChange(newEmail, code, mode) {
            await useAuthenticationStore().getCSRFToken();
            const response = await this.axios.post('/selfservice/change-email/verify/',
                {email: newEmail, code, mode});
            if (mode === 'replace') {
                this.email = response.data.current;
            }
            return response.data;
        },
        async removeEmail() {
            await useAuthenticationStore().getCSRFToken();
            await this.axios.post('/selfservice/emails/remove/');
            // The server revokes this session, so drop back to the login screen.
            this.authenticated = false;
            this.step = 'email';
            this.email = '';
            this.servers = [];
        },
        async logout() {
            try {
                await this.axios.post('/selfservice/logout/');
            } catch (e) {
                console.log(e);
            }
            this.authenticated = false;
            this.step = 'email';
            this.email = '';
            this.servers = [];
        },
    }
});
